import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContabilOutrosComponent } from './contabil-outros.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { RegrasCteModule } from './regras-cte/regras-cte.module';

@NgModule({
  imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        PoModule,
        PoPageDynamicTableModule,
        PoPageDynamicEditModule,
        RegrasCteModule
  ],
  declarations: [ContabilOutrosComponent]
})
export class ContabilOutrosModule { }
